import type { AnyObject } from '../types/common';

export const ui = (
  nameOrState?: string | AnyObject,
  state?: AnyObject,
): AnyObject => {
  if (!nameOrState) {
    return {};
  }
  let attributes: AnyObject = state || {};
  let attributesObject: AnyObject = {};
  if (typeof nameOrState === 'string') {
    attributesObject = {
      'data-ui': nameOrState,
    };
  } else if (!state) {
    attributes = nameOrState;
  }

  Object.keys(attributes).forEach((key: string) => {
    attributesObject[`data-ui-${key}`] = attributes[key];
  });

  return attributesObject;
};

export const updateObjectAtIndex = <T>(
  array: T[],
  index: number,
  fields: Partial<T>,
): T[] => [
  ...array.slice(0, index),
  {
    ...array[index],
    ...fields,
  },
  ...array.slice(index + 1, array.length),
];
